import { cloneDeep } from "lodash";
import { Reducer } from "redux";
import { updateObject } from "src/shared/updateObject";
import * as actionTypes from "src/store//actions/actionTypes";
import {
  IGetDataAction,
  INavigationClickedAction,
  INavigationFinishedAction,
  IScrollClickedAction,
  IScrollFinishedAction,
  ISetMediaLoadedAction,
  ISetScrollDirectionAction,
  IStateData
} from "src/store/StoreInterface";

const initialState = {
  content: {},
  id: 0,
  mediaLoaded: false,
  navigationClicked: false,
  scrollClicked: false,
  scrollDirection: "down"
};

const getData = (state: IStateData, action: IGetDataAction) => {
  const newData = cloneDeep(action.payload);
  return updateObject(state, {
    content: newData
  });
};

const navigationClicked = (
  state: IStateData,
  action: INavigationClickedAction
) => {
  return updateObject(state, {
    id: action.payload,
    navigationClicked: true
  });
};

const navigationFinished = (
  state: IStateData,
  action: INavigationFinishedAction
) => {
  return updateObject(state, {
    navigationClicked: false
  });
};

const setMediaLoaded = (state: IStateData, action: ISetMediaLoadedAction) => {
  return updateObject(state, {
    mediaLoaded: action.payload
  });
};

const setScrollDirection = (
  state: IStateData,
  action: ISetScrollDirectionAction
) => {
  return updateObject(state, {
    scrollDirection: action.payload
  });
};

const scrollClicked = (state: IStateData, action: IScrollClickedAction) => {
  return updateObject(state, {
    scrollClicked: true
  });
};

const scrollFinished = (state: IStateData, action: IScrollFinishedAction) => {
  return updateObject(state, {
    scrollClicked: false
  });
};

const reducer: Reducer = (
  state: IStateData = initialState,
  action:
    | IGetDataAction
    | INavigationClickedAction
    | INavigationFinishedAction
    | ISetMediaLoadedAction
    | ISetScrollDirectionAction
    | IScrollClickedAction
    | IScrollFinishedAction
) => {
  switch (action.type) {
    case actionTypes.GET_DATA:
      return getData(state, action);
    case actionTypes.NAVIGATION_CLICKED:
      return navigationClicked(state, action);
    case actionTypes.NAVIGATION_FINISHED:
      return navigationFinished(state, action);
    case actionTypes.SET_MEDIA_LOADED:
      return setMediaLoaded(state, action);
    case actionTypes.SET_SCROLL_DIRECTION:
      return setScrollDirection(state, action);
    case actionTypes.SCROLL_CLICKED:
      return scrollClicked(state, action);
    case actionTypes.SCROLL_FINISHED:
      return scrollFinished(state, action);
    default:
      return state;
  }
  return state;
};

export default reducer;



// WEBPACK FOOTER //
// ./src/store/reducers/data.tsx